import { Component, Input } from '@angular/core';

export type Notification = {
  title: string
  text: string
  button: string
  dismiss: boolean
  time: number
  color: string
  dark: boolean
  maxWidth: string
}
@Component({
  selector: 'mpro-notification-wrapper',
  templateUrl: './notification-wrapper.component.html',
  styleUrls: ['./notification-wrapper.component.scss']
})
export class NotificationWrapperComponent {

  @Input() notifications: Notification[] = []
  @Input() direction: "vertical" | "horizontal" = "horizontal"

  remove(i: number) {
    this.notifications = this.notifications.filter((_, c) => c !== i)
  }
}
